export const ChangePasswordSceneTranslation = {
  fi: {
    ChangePasswordScene: {
      title: 'Vaihda salasanasi',
    },
  },
};
